import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./locales/en";
import "./locales/zh-Hans";
import { App } from "./app";
import { useThemeStore, applyTheme, bindThemeToSystem } from "./stores/theme";
import { useI18nStore, applyLocaleToDocument } from "./lib/i18n";

// Apply theme + locale before first paint to avoid a flash.
applyTheme(useThemeStore.getState().mode);
applyLocaleToDocument(useI18nStore.getState().locale);
bindThemeToSystem();
useThemeStore.subscribe((s) => applyTheme(s.mode));
useI18nStore.subscribe((s) => applyLocaleToDocument(s.locale));

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
